// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedArtworks-module--container--1YBgJ","content":"RelatedArtworks-module--content--2iibc","grid":"RelatedArtworks-module--grid--3fOjg"};